<template>
    <el-dialog
        @close="closeDialog"
        class="leader-dialog"
        width="600px"
        :title="title"
        :show-close="true"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
    >
        <el-form class="leader-style-form" ref="unitForm" :model="unitForm" :rules="rules">
            <el-form-item label="部门名称" label-width="100px" prop="target_unit_name">
                <el-input v-model="unitForm.target_unit_name" maxlength="80" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="计费类型" label-width="100px" prop="target_unit_type">
                <el-select v-model="unitForm.target_unit_type">
                    <el-option
                        v-for="item in target_unit_types"
                        :key="item.target_unit_type_id"
                        :label="item.target_unit_type_name"
                        :value="item.target_unit_type_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="尖电费占比" label-width="100px" prop="sharp_price">
                <el-input v-model="unitForm.sharp_price" maxlength="8" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="峰电费占比" label-width="100px" prop="peak_price">
                <el-input v-model="unitForm.peak_price" maxlength="8" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="平电费占比" label-width="100px" prop="off_price">
                <el-input v-model="unitForm.off_price" maxlength="8" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="谷电费占比" label-width="100px" prop="shoulder_price">
                <el-input v-model="unitForm.shoulder_price" maxlength="8" show-word-limit></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" class="leader-common-button" @click="saveUnit">保存</el-button>
            <el-button size="small" class="leader-common-button" @click="dialogVisible = false">取消</el-button> 
        </span>
    </el-dialog>
</template>
<script>
import * as api from "@/http/target-config.js";
export default {
    data() {
        return {
            unitForm: {
                target_unit_name: "",
                target_unit_type: "",
                sharp_price: "",
                peak_price: "",
                off_price: "",
                shoulder_price: ""
            },
            target_unit_types: [
                {
                    target_unit_type_name: "峰谷平计费",
                    target_unit_type_id: "10"
                },
                {
                    target_unit_type_name: "固定电价计费",
                    target_unit_type_id: "20"
                }
            ],
            rules: {
                target_unit_name: [
                    {
                        required: true,
                        message: "请输入部门名称",
                        trigger: "blur",
                    },
                ],
                target_unit_type: [
                    {
                        required: true,
                        message: "请选择计费类型",
                        trigger: "change",
                    },
                ],
                sharp_price: [
                    { validator: this.$cv.floatValidatorNotRequired, trigger: 'blur' }
                ],
                peak_price: [
                    { validator: this.$cv.floatValidatorNotRequired, trigger: 'blur' }
                ],
                off_price: [
                    { validator: this.$cv.floatValidatorNotRequired, trigger: 'blur' }
                ],
                shoulder_price: [
                    { validator: this.$cv.floatValidatorNotRequired, trigger: 'blur' }
                ],
            },
        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
        },
        unitId: String,
        pUnitId: String,
        treeUnitId: String,
        title: {
            type: String,
            default: "新增部门",
        },
        unitName: String,
        target_unit_type: String,
        sharp_price: String,
        peak_price: String,
        off_price: String,
        shoulder_price: String,
    },
    watch: {
        dialogVisible(newVal) {
            if (newVal) {
                this.unitForm.target_unit_name = this.unitName;
                this.unitForm.target_unit_type = this.target_unit_type;
                this.unitForm.sharp_price = this.sharp_price;
                this.unitForm.peak_price = this.peak_price;
                this.unitForm.off_price = this.off_price;
                this.unitForm.shoulder_price = this.shoulder_price;
            }
        },
    },
    methods: {
        closeDialog(data, parentNode, type) {
            this.dialogVisible = false;
            this.$refs.unitForm.resetFields();
            this.$emit("update:dialogVisible", this.dialogVisible);
            this.$emit("appendTreeNode", data, parentNode, type);
        },
        saveUnit() {
            this.$refs.unitForm.validate((valid) => {
                if (valid) {
                    const treeData = {
                        p_target_unit_id: this.pUnitId,
                        target_unit_id: this.treeUnitId,
                        unit_id: this.unitId,
                        ...this.unitForm,
                    }
                    api.saveTargetUnitTree(treeData).then((res) => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                message: res.error_msg,
                                type: "success",
                            });
                            if(!this.treeUnitId) this.closeDialog(res.bus_json, this.pUnitId, 'add');//新增
                            else this.closeDialog(res.bus_json, this.pUnitId, 'edit');//编辑
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.access-control-dialog-2 {
    .el-input {
        width: auto !important;
    }
    .el-select {
        width: 100%;
    }
}
</style>